import _ from "lodash";
import { isValidJSON } from "../../ui/components/common/reviewComponents/reviewUtils";
import { getCompanyId } from "../utils"




const updateNestedObject = (obj, keys, value)=>{
    if(keys.length ===0) return obj;

    const updatedObj = {...obj};
    let current = updatedObj;

    for(let i= 0; i<keys.length-1;i++){
        const key = keys[i];
        current[key] = {...(current[key] || {})};
        current = current[key];
    }
    current[keys[keys.length -1]] = value;
    return updatedObj;
    
}


export const setOtherFilter = (keys, value, isCompanyWise=true)=>{
    const companyId = getCompanyId();
    const localStorageFilter = localStorage.getItem("otherFilter");
    const oldData = isValidJSON(localStorageFilter) ? JSON.parse(localStorageFilter) : {};
    const filterKeys = _.split(keys, '.');
    const companySpecificData =  oldData?.[companyId] || {};
    const newObj = updateNestedObject(companySpecificData, filterKeys, value);
    const newData = isCompanyWise ? {...oldData, [companyId]:newObj} : {...oldData, ...newObj};
    localStorage.setItem("otherFilter", JSON.stringify(newData));
}

export const getOtherFilter = (keys, isCompanyWise=true)=>{
    const companyId = getCompanyId();
    const localStorageData = localStorage.getItem("otherFilter");
    const parsedDt = isValidJSON(localStorageData) ? JSON.parse(localStorageData) :{};
    const filterKeys = _.split(keys, '.');
    const keyWiseData = isCompanyWise ? _.get(parsedDt?.[companyId], filterKeys) : _.get(parsedDt, filterKeys);
    return keyWiseData;

}